import React, { useEffect, useState } from "react"
import axios from "axios"
import Cookies from "js-cookie"
import { useNavigate } from "react-router-dom"
import { getFoodImageUrl } from "../utils/foodAvailability"

const API = "https://food-backend-9733.onrender.com"

const CartPage = () => {
  const [cart, setCart] = useState([])
  const [loadingItemId, setLoadingItemId] = useState(null)

  const navigate = useNavigate()

  const token = JSON.parse(
    Cookies.get("logincrd") || "{}"
  )?.token

  const fetchCart = () => {
    axios.get(`${API}/cart`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(res => setCart(res.data))
    .catch(err => console.log(err))
  }

  useEffect(() => {
    fetchCart()
  }, [])

  const increment = (food_id, selected_size) => {
    setLoadingItemId(food_id)

    axios.put(
      `${API}/cart/increment`,
      { food_id, selected_size },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
    .then(() => {
      fetchCart()
      window.dispatchEvent(new Event("srilekha-cart-updated"))
    })
    .catch(() => alert("Increment failed"))
    .finally(() => setLoadingItemId(null))
  }

  const decrement = (food_id, selected_size) => {
    setLoadingItemId(food_id)

    axios.put(
      `${API}/cart/decrement`,
      { food_id, selected_size },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
    .then(() => {
      fetchCart()
      window.dispatchEvent(new Event("srilekha-cart-updated"))
    })
    .catch(() => alert("Decrement failed"))
    .finally(() => setLoadingItemId(null))
  }

  const removeItem = (food_id, selected_size) => {
    setLoadingItemId(food_id)

    axios.delete(`${API}/cart/remove`, {
      data: { food_id, selected_size },
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(() => {
      fetchCart()
      window.dispatchEvent(new Event("srilekha-cart-updated"))
    })
    .catch(() => alert("Remove failed"))
    .finally(() => setLoadingItemId(null))
  }

  const grandTotal = cart.reduce(
    (sum, item) => sum + Number(item.total || 0),
    0
  )

  return (
    <div className="cart-page">

      <div className="cart-header">
        <button
          className="cart-back-btn"
          onClick={() => navigate("/")}
        >
          ←
        </button>

        <div>
          <h1>Your Cart</h1>
          <p>{cart.length} items in your cart</p>
        </div>
      </div>

      {cart.length === 0 && (
        <div className="empty-cart-box">
          <h2>🛒</h2>
          <h3>No items in cart</h3>
          <p>Add your favorite homemade foods.</p>

          <button onClick={() => navigate("/")}>
            Start Ordering
          </button>
        </div>
      )}

      <div className="cart-items-list">
        {cart.map(item => (
          <div
            key={item.id}
            className="cart-item-card"
          >
            <img
              src={getFoodImageUrl(
                item,
                API,
                "https://via.placeholder.com/100"
              )}
              alt={item.name}
              onError={(e) => {
                e.currentTarget.src = "/logo192.png"
              }}
            />

            <div className="cart-item-info">
              <h3>{item.name}</h3>

              <p className="cart-price">
                ₹ {item.price}
              </p>

              <p className="cart-size">
                Size: {item.selected_size || "250g"}
              </p>

              {(Number(item.is_out_of_stock) === 1 ||
                Number(item.stock_quantity) <= 0 ||
                Number(item.is_expired) === 1) && (
                <p className="cart-stock-warning">
                  Out of stock. Remove this item to checkout.
                </p>
              )}

              <div className="cart-qty-row">
                <button
                  onClick={() =>
                    decrement(
                      item.food_id,
                      item.selected_size || "250g"
                    )
                  }
                  disabled={loadingItemId === item.food_id}
                >
                  -
                </button>

                <span>{item.quantity}</span>

                <button
                  onClick={() =>
                    increment(
                      item.food_id,
                      item.selected_size || "250g"
                    )
                  }
                  disabled={
                    loadingItemId === item.food_id ||
                    Number(item.is_out_of_stock) === 1 ||
                    Number(item.stock_quantity) <= 0 ||
                    Number(item.is_expired) === 1
                  }
                >
                  +
                </button>
              </div>
            </div>

            <div className="cart-item-right">
              <h3>₹ {item.total}</h3>

              <button
                className="remove-cart-btn"
                onClick={() =>
                  removeItem(
                    item.food_id,
                    item.selected_size || "250g"
                  )
                }
                disabled={loadingItemId === item.food_id}
              >
                Remove
              </button>
            </div>
          </div>
        ))}
      </div>

      {cart.length > 0 && (
        <div className="cart-summary-box">
          <div>
            <p>Total Amount</p>
            <h2>₹ {grandTotal}</h2>
          </div>

          <button onClick={() => navigate("/checkout")}>
            Proceed To Checkout
          </button>
        </div>
      )}

    </div>
  )
}

export default CartPage
